import http from '../lib/http';

export default class Service {
    constructor() {
        this.client = http;
    }
}
